import React, { useMemo } from 'react'
// import SocialIcons from './social'
import Terms from './terms'

import {
  Wrapper,
  Content,
  Left,
  Logo,
  Right,
  Contact,
  LocationSection,
  Bottom,
  BText,
  Copyright,
  Creative,
  Title,
} from './index.styled'

const Footer = ({ className }) => {
  const currentYear = useMemo(() => new Date().getFullYear(), [])

  return (
    <Wrapper className={className}>
      <Content>
        <Left>
          <Logo />
          {/*    <SocialIcons /> */}
        </Left>
        <Right>
          <Contact>
            <div>
              <Title>CONTACT</Title>
              <a href="mailto:info@kanai.mx">info@kanai.mx</a>
            </div>
            <div>
              <Title>PRESS</Title>
              <a href="mailto:kanaimx@m18pr.com">kanaimx@m18pr.com</a>
            </div>
            {/* <a href={'tel:+525550814300'}>+52 55 5081 4300</a> */}
          </Contact>
          <LocationSection>
            <Title>Location</Title>
            <p>
              Carretera Federal 307 Cancún-Tulum
              <br /> Km 302 + 340, Lote 013, Mz 002
              <br /> Región 004, Municipio de Solidaridad
              <br /> Estado de Quintana Roo, México.
            </p>
          </LocationSection>
        </Right>
      </Content>
      <Bottom>
        <BText>
          <Copyright>
            COPYRIGHT &copy; {currentYear} KANAI. ALL RIGHTS RESERVED.
          </Copyright>
          <Creative>CREATIVE & WEBSITE DBOX</Creative>
        </BText>
        <Terms />
      </Bottom>
    </Wrapper>
  )
}

export default Footer
